export default __webpack_public_path__ + "static/media/icon-broker.61dc47b7.svg";